module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "artist"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "artistblock"
  }, [_c('svg', {
    staticClass: "svg100",
    attrs: {
      "ratio": "0.25",
      "fill": "#ffffff",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1920 480"
    }
  }, [_c('title', [_vm._v("artist_white")]), _c('polygon', {
    attrs: {
      "points": "0 0 1920 480 0 480 0 0"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "work wow4"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "worklist wow1"
  }, [_c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic01.jpg"),
      "alt": "柏均"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic02.jpg"),
      "alt": "佳瑄"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic03.jpg"),
      "alt": "健騰"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic04.jpg"),
      "alt": "博為"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic05.jpg"),
      "alt": "祐綸"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic06.jpg"),
      "alt": "瑩芷"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic07.jpg"),
      "alt": "樹緯"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic08.jpg"),
      "alt": "怡初"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "workpic",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/artist/indexpic09.jpg"),
      "alt": "廷瑋"
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "arrow_into",
    attrs: {
      "data-href": "/#/artist1"
    },
    on: {
      "click": function($event) {
        _vm.goArt()
      }
    }
  }, [_c('svg', {
    staticClass: "arrowtop",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 33.86 18.28"
    }
  }, [_c('title', [_vm._v("top")]), _c('path', {
    attrs: {
      "d": "M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "arrowbg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 90.86 93.28"
    }
  }, [_c('title', [_vm._v("btn")]), _c('path', {
    attrs: {
      "d": "M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z"
    }
  })])])]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookmark"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/v/artist.svg"),
      "alt": "多寶創作人"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "txtcontent nonefordesktop strip"
  }, [_c('h2', {
    staticClass: "wow1"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/artist1.svg"),
      "alt": "認識多寶創作人"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "wow2"
  }, [_vm._v("「純粹、專注、原創」"), _c('br'), _vm._v("因為有這些特質，他們為世界帶來不一樣的美麗")]), _vm._v(" "), _c('h4', {
    staticClass: "wow3"
  }, [_c('span', {
    staticClass: "work_0 show"
  }, [_vm._v("蒙娜麗莎對我微笑")]), _vm._v(" "), _c('span', {
    staticClass: "work_1"
  }, [_vm._v("美是一種本能")]), _vm._v(" "), _c('span', {
    staticClass: "work_2"
  }, [_vm._v("無敵萬能車")]), _vm._v(" "), _c('span', {
    staticClass: "work_3"
  }, [_vm._v("優遊自在的空間")]), _vm._v(" "), _c('span', {
    staticClass: "work_4"
  }, [_vm._v("小小色彩大大天空")]), _vm._v(" "), _c('span', {
    staticClass: "work_5"
  }, [_vm._v("想像世界畫不停手")]), _vm._v(" "), _c('span', {
    staticClass: "work_6"
  }, [_vm._v("簡單美")]), _vm._v(" "), _c('span', {
    staticClass: "work_7"
  }, [_vm._v("人之初")]), _vm._v(" "), _c('span', {
    staticClass: "work_8"
  }, [_vm._v("我的思緒與螺旋槳")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artistname"
  }, [_c('img', {
    staticClass: "name_0 show",
    attrs: {
      "src": require("../../img/artist/name01.svg"),
      "alt": "柏均"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_1",
    attrs: {
      "src": require("../../img/artist/name02.svg"),
      "alt": "佳瑄"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_2",
    attrs: {
      "src": require("../../img/artist/name03.svg"),
      "alt": "健騰"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_3",
    attrs: {
      "src": require("../../img/artist/name04.svg"),
      "alt": "博為"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_4",
    attrs: {
      "src": require("../../img/artist/name05.svg"),
      "alt": "祐綸"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_5",
    attrs: {
      "src": require("../../img/artist/name06.svg"),
      "alt": "瑩芷"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_6",
    attrs: {
      "src": require("../../img/artist/name07.svg"),
      "alt": "樹緯"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_7",
    attrs: {
      "src": require("../../img/artist/name08.svg"),
      "alt": "怡初"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_8",
    attrs: {
      "src": require("../../img/artist/name09.svg"),
      "alt": "廷瑋"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "name_bg",
    attrs: {
      "src": require("../../img/artist/name_bg.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "txtcontent noneform strip"
  }, [_c('h2', {
    staticClass: "wow1"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/artist1.svg"),
      "alt": "認識多寶創作人"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "wow2"
  }, [_vm._v("「純粹、專注、原創」"), _c('br'), _vm._v("因為有這些特質，他們為世界帶來不一樣的美麗")]), _vm._v(" "), _c('h4', {
    staticClass: "wow3"
  }, [_c('span', {
    staticClass: "work_0 show"
  }, [_vm._v("蒙娜麗莎對我微笑")]), _vm._v(" "), _c('span', {
    staticClass: "work_1"
  }, [_vm._v("美是一種本能")]), _vm._v(" "), _c('span', {
    staticClass: "work_2"
  }, [_vm._v("無敵萬能車")]), _vm._v(" "), _c('span', {
    staticClass: "work_3"
  }, [_vm._v("優遊自在的空間")]), _vm._v(" "), _c('span', {
    staticClass: "work_4"
  }, [_vm._v("小小色彩大大天空")]), _vm._v(" "), _c('span', {
    staticClass: "work_5"
  }, [_vm._v("想像世界畫不停手")]), _vm._v(" "), _c('span', {
    staticClass: "work_6"
  }, [_vm._v("簡單美")]), _vm._v(" "), _c('span', {
    staticClass: "work_7"
  }, [_vm._v("人之初")]), _vm._v(" "), _c('span', {
    staticClass: "work_8"
  }, [_vm._v("我的思緒與螺旋槳")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb38eac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Artist.vue
// module id = 262
// module chunks = 0